import { useSelector } from 'react-redux';

import { Characteristic } from 'enums/characteristic';
import { Functor } from 'functions/Functor';
import { getPriceString } from 'functions/numberToString';
import { getValueScopeLabel } from 'functions/valueScopeConversion';
import { ValueScopeInfo } from 'functions/valueScopeConversion';
import { convertToValueScope } from 'functions/valueScopeConversion';
import { RootState } from 'reducers/rootReducer';

interface IProps {
	value: number | null;
	currency: string;
	valueScopeInfo: ValueScopeInfo | null;
	characteristic?: Characteristic | null;
}

const PriceDisplay = (props: IProps) => {
	const reduxCultureCode: string = useSelector((state: RootState) => state.cultureCode);

	const getValue = (): string => {
		if (props.value !== null) {
			return Functor.From(props.value)
				.map((e) => convertToValueScope(e, props.valueScopeInfo))
				.map((e) => getPriceString(e, reduxCultureCode))
				.get();
		} else {
			return '0';
		}
	};

	const renderContent = () => {
		return (
			<div>
				<label style={{ whiteSpace: 'nowrap' }}>
					{getValueScopeLabel(
						props.valueScopeInfo?.valueScope ?? null,
						props.characteristic
					)}
				</label>
				<div className="form-control" style={{ whiteSpace: 'nowrap' }}>
					<b>{props.currency + ' ' + getValue()}</b>
				</div>
			</div>
		);
	};

	return <>{renderContent()}</>;
};

export default PriceDisplay;
